import Toggle from "../../components/Toggle/Toggle";
import { FaPen ,FaTrashAlt } from 'react-icons/fa';

export const productTableColumns = (openModal, clickDelete, openFileModal, update) => [
  { header: '개발일', accessor: 'devDt' },
  { header: '제품명', accessor: 'productName', align: 'left' },
  { header: '규격', accessor: 'specification' },
  { header: '제품코드', accessor: 'code' },
  
  { header: '단위', accessor: 'stockUnitCode' },
  { header: '담당 부서', accessor: 'department' },
  { header: '담당자', accessor: 'userName' },
  { header: '판매 가격', accessor: 'price', render: (row) => `${(row.price ?? 0).toLocaleString()} 원` },
  { header: '재고관리 사용', accessor: 'useStockManagement', render: (row) => (
    <Toggle
      isOn={row.useStockManagement}
      handleToggle={(e)=>{ e.stopPropagation(); update({productSeq : row.productSeq, useStockManagement : !row.useStockManagement});}}
      onText="사용"
      offText="미사용"
    />
  )},
  { header: '사용여부', accessor: 'isUseFlag', render: (row) => (
    <Toggle
      isOn={row.isUseFlag}
      handleToggle={(e)=>{ e.stopPropagation(); update({productSeq : row.productSeq, isUseFlag : !row.isUseFlag});}}
      onText="사용"
      offText="미사용"
    />
  )},
  { header: '첨부파일', accessor: 'attachments', render: (row) => <span onClick={(e) => {e.stopPropagation(); openFileModal(row)}}>📎</span> },
  { header: '수정', accessor: 'attachments', render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); openModal(2, 1, row)}} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); clickDelete(1, row)}} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];

export const productFormFields = [
  { key: "productSeq", label: "제품번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "devDt", label: "개발일", type: "date", size: 6, visible: true, required: false },
  { key: "userSeq", label: "담당자", type: "apiSelect", apiKey: "user", labelKey: "userName", valueKey: "userSeq", visible: true, required: true },
  { key: "productName", label: "제품명", type: "text", size: 6, visible: true, required: true },
  { key: "specification", label: "규격", type: "text", size: 6, visible: true, required: true },
  { key: "price", label: "판매 가격", type: "number", size: 6, visible: true, required: true },
  { key: "code", label: "제품 코드", type: "text", size: 6, visible: true, required: true },
  { key: "stockUnitCode", label: "단위", type: "text", size: 6, visible: true, required: true },
  { key: "useStockManagement", label: "재고 관리 사용", type: "checkbox", onText: "사용", offText: "미사용", size: 6, visible: true, required: true },
  { key: "safetyStockAmount", label: "안전 재고 수량", type: "number", size: 6, visible: true, required: true },
  { key: "isUseFlag", label: "사용 여부", type: "checkbox", onText: "사용", offText: "미사용", size: 6, visible: true, required: true, default: true },
  { key: "note", label: "비고", type: "text", size: 6, visible: false, required: false },
];

export const productSearchFormFields = [
  { key: "devDt", label: "개발일", type: "date", size: 6, visible: true },
  // { key: "devDtEnd", label: "개발일 (끝)", type: "date", size: 6, visible: true },
  { key: "userSeq", label: "담당자", type: "apiSelect", apiKey: "user", labelKey: "userName", valueKey: "userSeq", visible: true },
  { key: "productName", label: "제품명", type: "text", size: 6, visible: true },
  { key: "code", label: "제품 코드", type: "text", size: 6, visible: true },
  { key: "useStockManagement", label: "재고 관리", type: "checkbox", onText: "사용", offText: "미사용", size: 6, visible: true, default : false },
  { key: "useFlag", label: "사용 여부", type: "checkbox", onText: "사용", offText: "미사용", size: 6, visible: true, default : false }
];

export const processTableColumns = (openModal, clickDelete) =>  [
  { header: '공정 순서', accessor: 'sort'},
  { header: '공정명', accessor: 'processName' },
  { header: '공정CODE', accessor: 'processCode' },
  { header: '공임비', accessor: 'processFee', render: (row) => `${(row.processFee ?? 0).toLocaleString()} 원` },
  // { header: '소요 수', accessor: 'consume' },
  // { header: '소요 유형', accessor: 'stockUnitCode' },
  { header: '수정', accessor: 'attachments', render: (row) =>
    <span onClick={() => openModal(2, 2, row)} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); clickDelete(2, row)}} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];

export const processFormFields = [
  { key: "processStepSeq", label: "공정단계번호", type: "text", size: 6, visible: false, required: false },
  { key: "productSeq", label: "제품번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "sort", label: "공정 순서", type: "number", size: 6, visible: true, required: true },
  { key: "processSeq", label: "공정", type: "apiSelect", apiKey: "process", labelKey: "processName", valueKey: "processSeq", visible: true, required: true, paramKeys: ["productSeq"]},
  // { key: "consume", label: "소모량", type: "number", size: 6, visible: true, required: true },
  { key: "note", label: "비고", type: "text", size: 6, visible: false, required: false },
  { key: "regId", label: "등록자", type: "text", size: 6, visible: false, required: false },
  { key: "regDt", label: "등록일", type: "date", size: 6, visible: false, required: false },
  { key: "updId", label: "수정자", type: "text", size: 6, visible: false, required: false },
  { key: "updDt", label: "수정일", type: "date", size: 6, visible: false, required: false },
];

export const productBOMTableColumns = (openModal, clickDelete) =>  [
  { header: '자재명', accessor: 'materialName' },
  { header: '규격', accessor: 'specification' },
  { header: '자재 CODE', accessor: 'materialCode' },
  { header: '단가 평균', accessor: 'fee', render: (row) => `${(row.fee ?? 0).toLocaleString()} 원` },
  { header: '소요 수', accessor: 'consume' },
  { header: '수정', accessor: 'attachments', render: (row) =>
    <span onClick={() => openModal( 2, 3, row )} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); clickDelete(3, row)}} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];

export const productBOMFormFields = [
  { key: "productBOMSeq", label: "제품BOM번호", type: "text", size: 6, visible: false, required: false },
  { key: "productSeq", label: "제품번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "materialSeq", label: "자재", type: "apiSelect", apiKey: "material", labelKey: "materialName", valueKey: "materialSeq", visible: true, required: true },
  { key: "consume", label: "소모량", type: "number", size: 6, visible: true, required: true },
  { key: "note", label: "비고", type: "text", size: 6, visible: false, required: false, default: ''},
  { key: "sort", label: "정렬", type: "number", size: 6, visible: false, required: false, default: 1 },
  { key: "regId", label: "등록자", type: "text", size: 6, visible: false, required: false },
  { key: "regDt", label: "등록일", type: "date", size: 6, visible: false, required: false },
  { key: "updId", label: "수정자", type: "text", size: 6, visible: false, required: false },
  { key: "updDt", label: "수정일", type: "date", size: 6, visible: false, required: false },
]